export const FilePickerProgressStringMap: Record<string, string> = {
  FileUpload_Failed: _TL_('Upload failed. Please retry.'),
  FileUpload_Succeed: _TL_('Successfully uploaded'),
  '{{number}} of {{total}}': _TL_('{{number}} of {{total}}'),
};

export type FilePickerProgressStringMapType = typeof FilePickerProgressStringMap;
export type FilePickerProgressStringMapKey = keyof FilePickerProgressStringMapType;
